<template>
    <div style="padding: 10px;">
        <el-dialog  :visible.sync="viewVisible" width="40%" height="100%" :close-on-click-modal=false :before-close='closeDialog'>
            <div class="pdf" >
                <p class="arrow">
                    <span @click="changePdfPage(0)" class="turn" :class="{grey: currentPage==1}">Preview</span>
                    {{currentPage}} / {{pageCount}}
                    <span @click="changePdfPage(1)" class="turn" :class="{grey: currentPage==pageCount}">Next</span>
                </p>
                <pdf :src="pdfsrc"
                     :page="currentPage"
                     class="pdf1"
                     @num-pages="pageCount=$event"
                     @page-loaded="currentPage=$event"
                     @loaded="loadPdfHandler"
                ></pdf>
            </div>
        </el-dialog>
        <el-table
                size="mini"
                :data="tableData"
        >
            <el-table-column
                    prop="title"
                    label="资料名称"
            >
            </el-table-column>
            <el-table-column
                    prop="checkStatus"
                    label="审核状态"
            >
                <template slot-scope="scope">
                    <el-switch
                            v-if="scope.row.checkStatus == 1 || scope.row.checkStatus ==2 || scope.row.checkStatus ==''"
                            :width="50"
                            class="mr10 fl mt12"
                            v-model="scope.row.checkStatus"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            :active-value=2
                            :inactive-value=1
                            @change="checkPass(scope.row)"
                    >
                    </el-switch>
                    <el-switch
                            v-if="scope.row.checkStatus ==3 || scope.row.checkStatus ==4 "
                            :width="50"
                            class="mr10 fl mt12"
                            v-model="scope.row.checkStatus"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            :active-value=4
                            :inactive-value=3
                            @change="checkPass(scope.row)"
                    >
                    </el-switch>
                    <el-button v-if="scope.row.checkStatus == 1" class="" type="text" >
                        <el-tooltip class="item" effect="dark" :content="scope.row.checkResult | result" placement="top">
                            <span>原因</span>
                        </el-tooltip>
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column
                    prop="address"
                    label="操作" width="180">
                <template slot-scope="scope">
                    <el-button @click="uploadMaterial(scope.row)" type="text"  >预览</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import https from '@/https.js'
    import pdf from 'vue-pdf'

    export default {
        name: "",
        components: {
            pdf: pdf
        },
        props: ['courseId', 'catalogId', 'isNextStep'],
        data() {
            return {
                searchForm:{
                    pageSize:10,
                    page:1
                },
                total:100,
                tableData: [],
                viewVisible: false,
                pdfsrc: "",
                checkStatus: '',
                currentPage: 1,
                pageCount: 0,
            }
        },

        methods: {
          loadPdfHandler() {

          },
          changePdfPage (val) {
            // console.log(val)
            if (val === 0 && this.currentPage > 1) {
              this.currentPage--
              // console.log(this.currentPage)
            }
            if (val === 1 && this.currentPage < this.pageCount) {
              this.currentPage++
              // console.log(this.currentPage)
            }
          },
            closeDialog() {
                this.viewVisible = false;
            },
            uploadMaterial(row) {
                let params = {
                  fileUrl: row.filePath,
                  fileName: row.fileName
                }
                https.fetchPost("/question/filePreview" ,params,"","","blob" ).then((data) => {
                  this.viewVisible = true;
                  let file = window.URL.createObjectURL(data.data);
                  this.pdfsrc = file;
                }).catch(err=>{
                        console.log(err)
                    }
                )

            },
            checkPass(row) {

                if(row.checkStatus == 1) {
                    row.checkStatus = 3;
                }

                if(row.checkStatus == 2) {
                    row.checkStatus = 4;
                }

                let params = { // 0 目录 1资源
                    courseId: this.courseId,
                    resourceId: row.resourcesId,
                    resourceType: 1,
                    checkStatus: row.checkStatus
                };
                https.fetchPost('/courseCheck/checkPass',params ,"json").then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if(code == '200') {
                        this.$message({
                            type: 'success',
                            message: '操作成功'
                        });
                    } else {
                        this.$message({
                            type: 'info',
                            message: '加载失败'+msg
                        });
                    }
                }).catch(err=>{
                        console.log(err)
                    }
                )
            },
            //coreFile/list
            searchMaterial() {
                let params = {
                    courseId: this.courseId,
                    modelType: 5
                };
                https.fetchPost('/coreFile/list',params ,"json").then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if(code == '200') {
                        this.tableData = data.data.data;
                    } else {
                        this.$message({
                            type: 'info',
                            message: '加载失败'+msg
                        });
                    }
                }).catch(err=>{
                        console.log(err)
                    }
                )
            }
        },
      filters: {
        result(val) {
           if(!val || val== '') {
            return "资料内容违规";
          }
          return "资料内容"+val;
        }
      },
        created: function () {
            this.searchMaterial();
            if(this.pdfsrc) {
                this.pdfsrc = pdf.createLoadingTask(this.pdfsrc);
            }
        }
    }
</script>

<style>
    .pdf{
    }
    .pdf1 {
        width: 100%;
    }
    .annotationLayer {
        width: 800px;
    }
</style>